"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _AVNURAH2cjs = require('../__chunks/AVNURAH2.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');


var _5FW7ADLFcjs = require('../__chunks/5FW7ADLF.cjs');
require('../__chunks/IRJEBRAW.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/select/select-item-check.tsx
var _react = require('react');
var TagName = "span";
var useSelectItemCheck = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useSelectItemCheck2({ store, checked, ...props }) {
    const context = _react.useContext.call(void 0, _AVNURAH2cjs.SelectItemCheckedContext);
    checked = checked != null ? checked : context;
    props = _5FW7ADLFcjs.useCheckboxCheck.call(void 0, { ...props, checked });
    return props;
  }
);
var SelectItemCheck = _PTOCUU2Dcjs.forwardRef.call(void 0, function SelectItemCheck2(props) {
  const htmlProps = useSelectItemCheck(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.SelectItemCheck = SelectItemCheck; exports.useSelectItemCheck = useSelectItemCheck;
